import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import UserContext from './UserContext';

const RegisterPage = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmation) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch('/api/register/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password })
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('access', data.access);
        localStorage.setItem('refresh', data.refresh);
        setUser({ username, token: data.access });
        navigate('/songs');
      } else {
        const err = await response.json();
        setMessage(err.message || 'Registration failed.');
      }
    } catch (error) {
      console.error('Registration failed:', error);
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="login-root">
      <div className="terminal-prompt">&gt;signalbleed.nyc</div>
      <h2>Register</h2>

      {message && <p className="error-message">{message}</p>}

      <form onSubmit={handleRegister}>
        <div className="form-group">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
          />
        </div>
        <input type="submit" value="Register" />
      </form>

      <p>Already have an account? <a href="/login">Log In here.</a></p>
    </div>
  );
};

export default RegisterPage;

